import ActionText from '@/atoms/ActionText/ActionText';
import {useState} from 'react';
import {StyledAboutEvents, StyledAccordion, StyledEvents, StyledTitle} from './styles';
import {AboutEventsArtistPageProps, EventsComponentProps} from './typings';

const Events = ({events, keyPrefix}: EventsComponentProps): JSX.Element => {
  return (
    <>
      {events.map((event, index) => (
        <StyledEvents key={`${keyPrefix}-${index}`}>
          <dt>Event:</dt>

          <dd>{event.title}</dd>

          <dt>Dates:</dt>

          <dd>{event.dates}</dd>

          <dt>Venue:</dt>

          <dd>{event.venue}</dd>

          <dd>{event.description}</dd>
        </StyledEvents>
      ))}
    </>
  );
};

const AboutEventsArtistPage = ({
  previousEvents,
  upcomingEvents,
  className,
}: AboutEventsArtistPageProps): JSX.Element => {
  const title = 'Events';
  const [showPreviousEvents, setShowPreviousEvents] = useState(false);

  const togglePreviousEvents = () => {
    setShowPreviousEvents((prev) => !prev);
  };

  return (
    <>
      <StyledAboutEvents className={className}>
        <StyledTitle>
          {!!upcomingEvents?.length ? 'Upcoming events' : 'There are no upcoming events'}
        </StyledTitle>

        {!!upcomingEvents?.length && <Events events={upcomingEvents} keyPrefix="upcoming-events" />}

        {!!previousEvents?.length && (
          <>
            <ActionText onClick={togglePreviousEvents}>
              {showPreviousEvents ? 'Hide previous events' : 'Show previous events'}
            </ActionText>

            {showPreviousEvents && <StyledTitle>Previous events</StyledTitle>}

            {showPreviousEvents && <Events events={previousEvents} keyPrefix="previous-events" />}
          </>
        )}
      </StyledAboutEvents>

      <StyledAccordion title={title} strongTitle={false} className={className}>
        <StyledTitle>
          {!!upcomingEvents?.length ? 'Upcoming events' : 'There are no upcoming events'}
        </StyledTitle>

        {!!upcomingEvents?.length && <Events events={upcomingEvents} keyPrefix="upcoming-events" />}

        {!!previousEvents?.length && (
          <>
            <ActionText onClick={togglePreviousEvents}>
              {showPreviousEvents ? 'Hide previous events' : 'Show previous events'}
            </ActionText>

            {showPreviousEvents && <StyledTitle>Previous events</StyledTitle>}

            {showPreviousEvents && <Events events={previousEvents} keyPrefix="previous-events" />}
          </>
        )}
      </StyledAccordion>
    </>
  );
};

export default AboutEventsArtistPage;
